import setup from './setup';

export default [
  setup
];
